import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";

export interface IPostWorkshopMailNotifyBody {
  template: ObjectId;
  candidates: ObjectId[];
}

export const usePostWorkshopMailNotify = () => {
  const [state, execute, cancel] = workshopsAxios<void, IPostWorkshopMailNotifyBody, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, data: IPostWorkshopMailNotifyBody) => {
      return execute({ url: `/${id}/mail/notify`, data });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
